var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"9","viewBox":"0 0 9 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M1.628.629l6.373 6.373-6.373 6.373L.05 11.796l4.794-4.794L.05 2.208 1.63.628z","fill":"#919DAF"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }